import * as React from "react";
import { useEffect, useRef } from "react";
import { Box, Container, Typography } from "@mui/material";

const stats = [
  { end: 2000000, label: "Instagram\ncreators\nindexed",    format: () => "2M+"   },
  { end: 95,      label: "Creator\ncontact\nreach rate",    format: (v) => `${v}%` },
  { end: 10,      label: "Faster than\nmanual research",   format: (v) => `${v}x` },
  { end: 3000,    label: "Campaigns\npowered",             format: (v) => `${v}+` },
];

const easeOutQuart = (t) => 1 - Math.pow(1 - t, 4);

function animateCounter(el, stat, duration = 1800) {
  const start = performance.now();
  const step = (now) => {
    const progress = Math.min((now - start) / duration, 1);
    const value = Math.floor(easeOutQuart(progress) * stat.end);
    el.textContent = stat.format(value);
    if (progress < 1) requestAnimationFrame(step);
    else el.textContent = stat.format(stat.end);
  };
  requestAnimationFrame(step);
}

function StatsBar() {
  const containerRef = useRef(null);
  const animated     = useRef(false);
  const numRefs      = useRef([]);

  useEffect(() => {
    if (!containerRef.current) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !animated.current) {
          animated.current = true;
          numRefs.current.forEach((el, i) => {
            if (el) animateCounter(el, stats[i]);
          });
        }
      },
      { threshold: 0.3 }
    );
    observer.observe(containerRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <Box
      ref={containerRef}
      className="reveal"
      sx={{
        bgcolor: "#0a1630",
        py: { xs: "40px", md: "48px" },
        px: { xs: "20px", md: "80px" },
      }}
    >
      <Container maxWidth="xl">
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr 1fr", md: "1fr 1fr 1fr 1fr" },
            gap: { xs: 4, md: 0 },
          }}
        >
          {stats.map((stat, i) => (
            <Box
              key={i}
              sx={{
                textAlign: "center",
                borderRight: {
                  md: i < 3 ? "1px solid rgba(255,255,255,0.08)" : "none",
                },
                px: { md: 3 },
              }}
            >
              <Typography
                ref={(el) => (numRefs.current[i] = el)}
                sx={{
                  fontSize: "clamp(32px, 4vw, 44px)",
                  fontWeight: 800,
                  color: "#FF6B35",
                  lineHeight: 1,
                }}
              >
                {stat.format(0)}
              </Typography>
              <Typography
                sx={{
                  fontSize: "13px",
                  color: "rgba(255,255,255,0.5)",
                  mt: "6px",
                  lineHeight: 1.4,
                  whiteSpace: "pre-line",
                  maxWidth: "120px",
                  mx: "auto",
                }}
              >
                {stat.label}
              </Typography>
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
}

export default StatsBar;
